import { render, staticRenderFns } from "./NotAuthorize.vue?vue&type=template&id=5554cb2c&scoped=true&"
import script from "./NotAuthorize.vue?vue&type=script&lang=js&"
export * from "./NotAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./NotAuthorize.vue?vue&type=style&index=0&id=5554cb2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5554cb2c",
  null
  
)

export default component.exports